export const EtiquetasGenerales_ES = {
    General: {
        //---------------------ENCABEZADOS------------------------------
        Et_TituloEliminaRegistro: 'Eliminar registro',
        Et_TituloCriterioBusqueda: 'Criterio de búsqueda',
        Et_TituloCamposDinamicos: 'Mis Campos',
        Et_TituloConfirmaregistro: 'Confirmación',
        Et_TituloDialogoMensaje: 'Mensaje',
        //---------------------Confirmaciones---------------------------
        TextoEliminarRegistro: '¿Desea eliminar el registro? ',
        //---------------------BOTONES----------------------------------
        Et_tbnInsertar: 'Crear',
        Et_tbnEditar: 'Editar',
        Et_tbnGuardar: 'Guardar',
        Et_tbnAceptar: 'Aceptar',
        Et_tbnCancelar: 'Cancelar',
        Et_tbnEliminar: 'Eliminar',
        Et_tbnFavorito: 'Favorito',
        Et_tbnLimpiar: 'Limpiar',
        Et_tbnSi: 'Sí',
        Et_tbnNo: 'No',
        Et_tbnAtras: 'Atrás',
        Et_tbnSiguiente: 'Siguiente',
        Et_tbnBusqueda: 'Buscar',
        Et_tbnCerrarSesion: 'Cerrar Sesión',
        Et_tbnSubir: 'Subir',
        Et_tbnBajar: 'Bajar',
        Et_tbnCerrar: 'Cerrar',
        Et_tbnEliminarRegistro: "Sí, eliminar el registro",
        Et_tbnMantenerRegistro: "No, mantener el registro",
        Et_tbnAgregar: 'Agregar',
        //---------------------TABLAS-----------------------------------
        Et_tblAcciones: 'Acciones',
        Et_tblDetalles: 'Detalle',
        Et_tblTableEmty: 'Ningún dato disponible',
        Et_tblItems: 'Filas por página: ',
        Et_tblItemsDescription: 'Filas visibles de la {0} a la {1} de un total de {2}.',
        //---------------------TEXTOS--------------------------------
        Et_tblSiTildado: 'Sí',
        Et_lblEs: 'Español',
        Et_lblEn: 'Inglés',
        Et_lblAllElemnts: 'Todas',
        Et_tblNombre: 'Nombre',
        Et_tblCode: 'Código',
        Et_tblDescripcion: 'Descripción',
        Et_tblEstado: 'Estado',
        Et_tblActivo: 'Activo',
        Et_tblInactivo: 'Inactivo',
        Et_Select: 'Seleccione',
        Et_Seleccionar: 'Seleccionar',
        Et_NoAplica: 'No aplica',
        Et_tblCusIde: 'Identificación',
        Et_tblCusOtherIdeShort: 'CIF',
        Et_tblCusOtherIde: 'Número CIF',
        Et_tblObservation: 'Observaciones',
        Et_tblClasificacion: 'Clasificación',
        Et_tblCategoria: 'Categoría',
        Et_tblTipo: 'Tipo',
        Et_tblTipoRequisito: 'Obligatorio',
        Et_tblTipoOpcional: 'Opcional',
        Et_tblBloque: 'Bloque',
        Et_tblRequisitos: 'Requisitos',
        Et_tblFormatoArchivosPermitidos: 'Formatos de archivos',
        Et_Requisito: 'Requisito',
        Et_tblRequisitoConAdjunto: 'El requisito requiere adjuntar archivo.',
        Et_tblAdminFormatoAdjunto: 'Gestionar formatos permitidos',
        Et_tblAdjunto: 'Adjunto',
        Et_tblSinOpciones: 'Sin opciones',
        Et_tblDatosGenerales: 'Datos generales',
        Et_tblPrograma: 'Programa',
        Et_tblProgramas: 'Programas',
        Et_tblTipoPeriodo: 'Tipo de Periodo',
        Et_tblPeriodo: 'Periodo',
        Et_tblAnno: 'Año',
        Et_tblSede: 'Sede',
        Et_tblSedes: 'Sedes',
        Et_tblFechaAprobacion: 'Fecha Aprobación',
        Et_tblEstudiante: 'Estudiante',
        Et_tblAprobacion: 'Aprobación',
        Et_tblArchivo: 'Archivo',
        Et_tblCompania: 'Compañía',
        Et_tblComentarios: 'Comentarios',
        Et_tvlAula: 'Aula',
        Et_tvlAulas: 'Aulas',
        Et_tvlRecursos: 'Recursos',
        Et_tvlEdificio: 'Edificio',
        Et_tvlPiso: 'Piso',
        Et_tvlTipoAula: 'Tipo de Aula',
        Et_tvlCapacidad: 'Capacidad',
        Et_tvlDireccion: 'Dirección',
        Et_tvlAulaDiscapaitados: 'Habilitada para discapacitados',
        Et_tvlCantidad: 'Cantidad',
        Et_tblAprobado: 'Aprobado',
        Et_tblPendiente: 'Pendiente',
        Et_tvlJornada: 'Jornada',
        Et_tvHoraIncio: 'Hora Inicio',
        Et_tvHoraFinal: 'Hora Final',
        Et_tvDiasSemana: 'Días de semana',
        Et_tvLunes: 'Lunes',
        Et_tvMartes: 'Martes',
        Et_tvMiercoles: 'Miércoles',
        Et_tvJueves: 'Jueves',
        Et_tvViernes: 'Viernes',
        Et_tvSabado: 'Sábado',
        Et_tvDomingo: 'Domingo',
        Et_tvListaRecursos: 'Lista de recursos',
        Et_tblInfoRegistrosActivos: '*Solo se mostrarán registros activos.',
        Et_FiltroDscRecursos: 'Descripción del recurso',
        Et_FiltroDscSede: 'Descripción de la sede',
        Et_FiltroDscCursos: 'Descripción del curso',
        Et_FiltroDscFormatos: 'Descripción del formato',
        Et_tblGrupo: 'Grupo',
        Et_tblSubGrupo: 'Subgrupo',
        Et_tblPublicada: 'Publicada',
        Et_tblCupo: 'Cupo',
        Et_tblIniciaT: 'Inicia: ',
        Et_tblFinalizaT: 'Finaliza: ',
        Et_Profesor: 'Profesor',
        Et_Dia: 'Día',
        Et_Horario: 'Horario',
        Et_tblDetalleFechas: 'Detalle de Fechas',
        Et_tblPeriodoAcademico: 'Periodo Académico',
        Et_tblInscripciones: 'Inscripciones',
        Et_tblInicioPeriodo: 'Inicio periodo',
        Et_tblFinPeriodo: 'Fin periodo',
        Et_tblUsuario: 'Usuario',
        Et_tblCliente: 'CIF',
        Et_tblAccion: 'Acción',
        Et_tblFechaDesde: 'Fecha desde',
        Et_tblFechaHasta: 'Fecha hasta',
        Et_tblGeneral: 'General',
    },
    Buscadores: {
        Et_lblUsuarios: 'Buscar Usuarios',
        Et_lblCarreras: 'Buscar Carreras',
        Et_lblCursos: 'Buscar Cursos',
        Et_lblRegistrosActivos: '*Solo se mostrará registros activos.',
        Et_lblProgramas: 'Buscar Programas',
        Et_lblSedes: 'Buscar Sedes',
        Et_lblClientes: 'Buscar CIF',
        Et_lblIngresarID: 'Digitar identificación',
        Et_lblCursosProgramas: 'Buscar cursos programas',
    },
    Reportes: {
        Et_TituloPrincipal: 'Reportes',
        Et_LblExportaPdf: 'Pdf',
        Et_LblExportaXls: 'Xls',
        Et_LblExportaDoc: 'Doc'
    },
    Login: {
        Et_btnAcceso: 'Acceso',
        Et_btnAccesoAAD: 'Continuar con Office 365',
        Et_TituloPrincipal: 'Iniciar sesión usuario',
        Et_txtUsuario: 'Ingrese su Usuario',
        Et_txtPassword: 'Ingrese su contraseña'
    },
    AppBarLang: {
        Et_TituloPrincipal: 'Sistema de Gestión Académica'
    },
    DetalleModulo: {
        Et_BtnAccion: 'Ir al Módulo',
        Et_TituloFavoritos: 'MÓDULOS MÁS UTILIZADOS',
    },
    IdiomaModal: {
        Et_TituloPrincipal: 'Seleccione su idioma'
    },
    MenuDerecha: {
        Et_btnSalir: 'Salir',
    },
    MenuIzquierda: {
        Et_LblHeader: 'Módulo Académico',
        Et_LblFavoritos: 'Favoritos',
        Et_LblSubmodulos: 'Menú'
    },
    IdleTimeOutModal: {
        Et_txtFinSesionTitulo: 'Su tiempo de sesión ha expirado.',
        Et_txtFinSeguir: '¿Desea seguir navegando?'
    },
    CalendarioSimple: {
        Date: 'Fecha',
        Time: 'Tiempo',
        Event: 'Evento',
        AllDay: 'Todo el día',
        Week: 'Semana',
        Work_week: 'Semana de trabajo',
        Day: 'Día',
        Month: 'Mes',
        Previous: 'Atrás',
        Next: 'Siguiente',
        Today: 'Hoy',
        Yesterday: 'Ayer',
        Tomorrow: 'Mañana',
        Agenda: 'Agenda',
        NoEventsInRange: 'No hay eventos en este rango.',
        ShowMore: 'más',
        CrearEvento: 'Crear evento'
    },
    CargandoModal: {
        Et_Procesando: "Procesando, por favor espere.",
        Et_Cargando: "Cargando, por favor espere."
    },
    ToolbarButtons: {
        Et_BtnEnviar: 'Enviar',
        Et_BtnCamposDinamicos: 'Mis campos',
        Et_BtnAjustes: 'Ajustes',
        Et_BtnImprimir: 'Imprimir'
    },
    DialogoSubirImagen: {
        Et_TituloPrincipal: 'Subir Imagen',
        Et_FotoPerfil: 'Foto de perfil',
        Et_BtnSubir: 'Cargar Foto',
        Et_BtnCamara: 'Tomar Foto'
    },
    DialogoSubirArchivo: {
        Et_TituloPrincipal: 'Subir Archivo',
        Et_NombreArchivo: 'Nombre archivo'
    },
    DialogoWebCam: {
        Et_TituloPrincipal: 'Capturar Imagen',
        Et_BtnCamara: 'Capturar'
    },
    ListaCompanias: {
        Et_TituloPrincipal: 'Consulta compañías',
        Et_Descripcion: 'Gestión de parámetros de la compañía.'
    },
    MantenimientoCompanias: {
        Et_TituloPrincipal: 'Mantenimiento Compañía',
        Et_Descripcion: 'Gestión de parámetros de la compañía.'
    },
    ControlFlujoCliente: {
        Et_TituloPrincipal: 'Flujo de Procesos',
    },
    ListaSedes: {
        Et_TituloPrincipal: 'Consulta sedes',
        Et_Descripcion: 'Gestión de parámetros de la sede.'
    },
    MantenimientoSedes: {
        Et_TituloPrincipal: 'Mantenimiento sede',
        Et_Descripcion: 'Gestión de parámetros de la sede.'
    },
    Mensajeria: {
        Et_TituloPrincipal: 'MENSAJERÍA',
        Et_Descripcion: 'Mis mensajes',
        Et_LblBuzonEntrada: 'Buzón de entrada',
        Et_LblBuzonSalida: 'Buzón de salida',
        Et_LblNuevoMensaje: 'Nuevo mensaje',
        Et_LblResponderMensaje: 'Responder mensaje',
        Et_LblLeidos: 'Leídos',
        Et_LblMensajeDe: 'Mensaje de:',
        Et_LblMensajeDescrip: 'Descripción del Mensaje',
        Et_LblFechaHora: 'Fecha y hora',
        Et_LblElementosSeleccionados: '{0} mensajes seleccionados',
        Et_LblElementosSeleccionadosEliminar: '¿Desea eliminar los {0} mensajes seleccionados?',
        Et_LblMarcarLeidos: 'Marcar como leídos',
        Et_LblMarcarNoLeidos: 'Marcar como no leídos',
        Et_LblEliminarMultiples: 'Eliminar mensajes seleccionados',
        Et_LblPara: 'Para:',
        Et_LblCopia: 'CC:',
        Et_tblAsunto: 'Asunto',
        Et_tblDestinatario: 'Destinatario',
        Et_tblRemitente: 'Remitente',
        Et_tblDescartar: 'Descartar',
        Et_tblDetallesMensaje: 'Detalles del mensaje',
        Et_tblResponder: 'Responder',
        Et_tblAdjuntarArchivo: 'Adjuntar archivo',
        Et_LblBuscarCorreo: 'Buscar correo',
    },
    BuscadorGlobal: {
        Et_Placeholder: "Buscar",
        Et_Recientes: "Búsquedas Recientes",
        Et_LimpiarTodo: "Limpiar todo",
        Et_SinResultados: "No se encontraron resultados para",
        Et_IntentaOtrosTerminos: "Intenta con otros términos",
        Et_SinPermisos: "No tiene permiso para acceder a esta opción, ponerse en contacto con su administrador.",
        Et_Resultados: "Resultados",
        Et_Encontrado: "encontrado",
        Et_Encontrados: "encontrados",
        Et_Buscando: "Buscando...",
        Et_EscribeParaBuscar: "Escribe para buscar...",
    },
};